import classNames from 'classnames';

// styles
import s from './SellerRatingWithImage.sss';

// types
type SellerRatingWithImageProps = {
  text: string;
  imageLink?: string | null;
  title: string;
  className?: string;
};

export const SellerRatingWithImage: React.FC<SellerRatingWithImageProps> = ({
  text,
  imageLink,
  title,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <div className={s.title}>
      {title}
    </div>
    <div className={s.blockInfo}>
      <div className={s.imgBlock}>
        {imageLink && <img className={s.img} src={imageLink} alt="SecureImage" />}
        <span>{text}</span>
      </div>
    </div>
  </div>
);
